
import { ref, getCurrentInstance, computed } from 'vue';

export const useVideoList = () => {
  const { proxy } = getCurrentInstance() as { proxy: Record<string, any> }
  const loading = ref(false)
  const cursor = computed(() => proxy.$store.state.newDiscoverModule.cursor)
  const finished = computed(() => cursor.value === 'no_more')

  const onLoad = async () => {
    await proxy.$store.dispatch('newDiscoverModule/getCategoryCardList', { $axios: proxy.$axios, route: proxy.$route, $store: proxy.$store})
    loading.value = false
    proxy.$bus.emit('scrollAutoPlayVideos')
  }

  const loadMorePost = () => {
    loading.value = true;
    onLoad();
  }

  return {
    cursor,
    finished,
    loading,
    loadMorePost,
    onLoad,
  };
};

